export default __webpack_public_path__ + "static/media/microsoft-store.42b4b622.svg";